import Blazy from 'blazy';

document.addEventListener('DOMContentLoaded', () => {
  window.blazy = new Blazy();
});



// WEBPACK FOOTER //
// ./scripts/components/events.js